import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { VegaLiteChart } from './VegaLiteChart';
export function isVegaLiteSpec(spec) {
    return spec.library === 'vega-lite' && typeof spec.spec === 'object';
}
export function isRechartsSpec(spec) {
    return spec.library === 'recharts' || spec.library === undefined;
}
function isNativeVegaLiteSpec(spec) {
    return typeof spec.$schema === 'string' &&
        spec.$schema.includes('vega');
}
export const AgentChart = memo(function AgentChart({ spec, artifactRunId }) {
    if (isVegaLiteSpec(spec)) {
        return _jsx(VegaLiteChart, { spec: spec, artifactRunId: artifactRunId });
    }
    if (isNativeVegaLiteSpec(spec)) {
        return _jsx(VegaLiteChart, { spec: { library: 'vega-lite', spec }, artifactRunId: artifactRunId });
    }
    return (_jsxs("div", { className: "my-5 rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-200", children: ["Recharts chart rendering has been retired. Use a Vega-Lite chart spec (", _jsx("code", { children: "library: \"vega-lite\"" }), " with ", _jsx("code", { children: "spec" }), ")."] }));
}, (prevProps, nextProps) => {
    return JSON.stringify(prevProps.spec) === JSON.stringify(nextProps.spec)
        && prevProps.artifactRunId === nextProps.artifactRunId;
});
//# sourceMappingURL=AgentChart.js.map